<template lang="pug">
div
  .topo
    img#logo(
      :src='LOGO',
      alt='sicarf',
      name="logo"
      @click="goHome"
    )
    .info
      app-pesquisa-geral.pesquisaGeral(v-if="isAp && hasNotificacao")
      template(v-if="hasListagemModelo")
        .el-dropdown-link(v-if="isVisualizarGestaoProcessos")
          el-tooltip#tooltip(
            effect='dark',
            content='Gestão processos/usuários',
            placement="bottom",
          )
            font-awesome-icon(@click="goToGestaoProcesso" icon="user-friends")
      app-notificacao.notificacaoUser(v-if="hasNotificacao" :usuario="usuario")
      notificacao(v-if="hasNotificacaoModulo" :usuario="usuario")
      template(v-if="hasListagemModelo && hasPermissaoCriarModelos")
        .el-dropdown-link.listagemModelo
          el-tooltip#tooltip(
            effect='dark',
            content='Listagem de modelos',
            placement="bottom",
          )
            font-awesome-icon(@click="goToListagemModelos" icon="file-alt")
      .user(v-if="!$route.meta.isPublic")
        .usuario
          i.fas.fa-user-circle
          .descricao
            el-dropdown.dropUser(v-if="usuario && (!usuario.hasPerfilExterno || usuario.perfilSelecionado.codigo === 'VISTORIA_EXTERNO')")
              span.userPrimary &nbsp {{ nomeUsuario | truncate(10, '...') }}
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot='dropdown')
                el-dropdown-item
                  a(@click="goToMeusDados", style="color:black; text-decoration: none")
                    | Meus dados
            span(v-else) &nbsp {{ nomeUsuario | truncate(10, '...') }}
            span.nomePerfil(v-if="nomePerfil") &nbsp {{ nomePerfil }}
        .logout
          app-action-button(
            icone="sign-out-alt",
            id="button_logout"
            @click="sair",
            cor="#a7b2bb",
            text="Sair",
            fontSize="25"
          )
</template>

<script>
import AppActionButton from '@/components/AppActionButton'
import { mapActions, mapGetters, mapState } from 'vuex'
import AppNotificacao from '@/screens/analise/components/AppNotificacao'
import AppPesquisaGeral from '../screens/analise/components/AppPesquisaGeral.vue'
import ModelosListagem from '@/screens/analise/ModelosListagem'
import Notificacao from '@/components/Notificacao'
const { isVisualizarGestaoProcessos, separatorByUnderscore, criarModelos } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  data () {
    return {
      isVisualizarGestaoProcessos: false,
      isAp: process.env.ESTADO === 'ap'
    }
  },

  components: {
    AppActionButton,
    AppNotificacao,
    AppPesquisaGeral,
    ModelosListagem,
    Notificacao
  },

  props: {
    notificacao: {
      type: Boolean,
      default: true
    },

    hasListagemModelo: {
      type: Boolean,
      default: true
    },

    hasNotificacaoModulo: {
      type: Boolean,
      default: false
    },
    isManutencao: {
      type: Boolean,
      require: false,
      default: false
    }
  },

  created () {
    this.isVisualizarGestaoProcessos = isVisualizarGestaoProcessos(this.usuario?.perfilSelecionado?.codigo)
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    ...mapState({
      LOGO: state => state.userInterface.dadosEstado.LOGO
    }),

    hasNotificacao () {
      return this.usuario && this.notificacao
    },

    hasPermissaoCriarModelos () {
      return !criarModelos.perfisExcluidos.includes(separatorByUnderscore(this.usuario.perfilSelecionado.codigo)) ||
      criarModelos.perfisExcecoes.includes(this.usuario.perfilSelecionado.codigo)
    },

    nomeUsuario () {
      if (!this.usuario) {
        return '-'
      }

      return this.usuario.pessoa.tipo === 'PF' ? this.usuario.pessoa.pessoaFisica.nome : this.usuario.pessoa.pessoaJuridica.razaoSocial
    },

    nomePerfil () {
      if (!this.usuario) {
        return '-'
      }

      return this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.nome : null
    }
  },

  methods: {
    ...mapActions({
      clearPerfil: 'auth/clearPerfil',
      getToken: 'auth/getToken'
    }),

    perfisWithOutNotificacao (setor) {
      const perfisWithOutNotificacao = ['CENTRAL_DO_INTERESSADO', 'FINANCEIRO', 'PORTAL_DE_SEGURANCA', 'RELATORIOS']
      return perfisWithOutNotificacao.includes(setor)
    },

    async sair () {
      if (this.$route.name === 'selecionarModulo') {
        this.$router.push({ name: 'logout' })
      } else if (this.$route.name === 'selecionarPerfil' || this.usuario.qtdPerfis === 1) {
        this.$router.push({ name: 'selecionarModulo' })
      } else {
        this.$router.push({ name: 'selecionarPerfil' })
      }
    },

    async goToMeusDados () {
      let location = process.env.URL_MODULO_GESTAO_DADOS
      if (process.env.NODE_ENV === 'development') {
        const token = await this.getToken()
        location += `?token=${token}`
      }
      window.location.href = location
    },

    goToGestaoProcesso () {
      this.$router.push({ name: 'gestao-processo-usuario' })
    },

    goToListagemModelos () {
      if (!this.isManutencao) {
        this.$router.push({ name: 'listagem-modelos-despacho-notificacao' })
      } else {
        this.$router.push({ name: 'listagem-modelos-despacho-notificacao-manutencao' })
      }
    },

    goHome () {
      this.$router.push({ name: this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.paginaInicial : 'selecionarModulo' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.topo {
  width: 100%;
  height: $header-size;
  display: flex;
  align-items: center;
  padding: 0 5% 0 5%;
  justify-content: space-between;
  background-color: #f3f7fa;
  font-size: xx-large;
  border-bottom: solid 1px #eaeef1;

  .el-dropdown-link {
    cursor: pointer;
    margin-right: 0.5em;
    color: $lightgray-color;
  }

  .pesquisaGeral {
    cursor: pointer;
    margin-right: 2em;
  }

  .el-dropdown-link:hover {
    transition: color 0.3s;
    color: $color-primary;
  }

  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .light {
    color: $lightgray-color;
  }

  span {
    font-size: 15px;
    color: #424242;
  }

  #logo {
    height: 100%;
    width: auto;
    cursor: pointer;
  }

  .user {
    display: flex;
    align-items: center;
    color: #a7b2bb;
    justify-content: space-between;

    .usuario {
      display: flex;
      align-items: center;
      .descricao {
        text-align: left;
        display: flex;
        flex-direction: column;
        .nomePerfil {
          opacity: 0.8;
        }
      }
    }
    .logout {
      margin-left: 1vw;
      display: flex;
      align-items: center;
      font-size: 15px;
      .icon {
        font-size: inherit !important;
      }
    }
  }
}

@media (max-width: 780px) {
  .topo {
    display: block;
    height: 130px !important;
    #logo {
      height: 35% !important;
      position: relative;
      right: 15px;
      top: 60px;
    }

    .info {
      flex-wrap: initial !important;
    }
    .el-dropdown-link {
      position: relative;
      top: 20px;
      left: 185px;
    }

    .listagemModelo {
      position: relative;
      top: 10px;
    }

    .notificacaoUser {
      top: 20px;
      left: 180px
  ;
    }
    .user {

      .logout {
        position: relative;
        bottom: 45px;
        right: 45px;
      }

      .usuario {
        position: relative;
        bottom: 40px;
        right: 60px;
        .descricao{
          position: relative;
          left: 15px;
          flex-direction: row;
        }
      }
    }
  }
}

@media (max-width: 1256px) {
  .topo {
    height: 90px;

    #logo {
      height: 50%;
    }
    .user .usuario .descricao {
      padding-left: 13px
    }

    .info {
      flex-wrap: wrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainHeader.vue